/* eslint-disable max-classes-per-file */
import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { IDistcpSetting } from 'app/shared/components/distcp-setting/IDistcpSetting';

import { IAttribute } from 'app/model/base/annotation';
import { Owned } from 'app/model/base/named';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { HdfsLinkedService } from 'shell-models-lib';

@Metamodel.model({
    name: 'DistcpSetting',
    display: [ stringResources.DistcpSetting ]
})
export class DistcpSetting extends Owned implements IDistcpSetting {
    public static readonly RESOURCE_MANAGER_ENDPOINT: IAttribute;
    public static readonly TEMP_SCRIPT_PATH: IAttribute;
    public static readonly DIST_CP_OPTIONS: IAttribute;
    public static readonly DELETE_FILE_AFTER_COMPLETION: IAttribute;

    @Metamodel.attribute({})
    public useDistCp: boolean = false;

    @Metamodel.attribute({
        templatable: true,
        association: 'RESOURCE_MANAGER_ENDPOINT',
        display: stringResources.SourceActivity_SourceTab_DistCpResourceManagerEndpoint_Label,
        constraint: {
            required: ['useDistCp']
        }
    })
    public resourceManagerEndpoint: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'TEMP_SCRIPT_PATH',
        display: stringResources.SourceActivity_SourceTab_DistCpTempScriptPath_Label,
        constraint: {
            required: ['useDistCp']
        }
    })
    public tempScriptPath: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'DIST_CP_OPTIONS',
        display: stringResources.SourceActivity_SourceTab_DistCpOptions_Label
    })
    public distCpOptions: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'DELETE_FILE_AFTER_COMPLETION',
        display: stringResources.DeleteFilesAfterCompletion_Label
    })
    public deleteFilesAfterCompletion?: boolean;
}

@Metamodel.model({
    name: 'HdfsReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(HdfsLinkedService)
    }
})

export class HdfsStoreReadSettings extends BlobTypeStoreReadSettings {
    public distCpSetting: DistcpSetting = Owned.create<DistcpSetting>(Metamodel.modelFor(DistcpSetting), this);
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        templatable: true,
        association: 'DELETE_FILE_AFTER_COMPLETION',
        display: stringResources.DeleteFilesAfterCompletion_Label,
        constraint: {
            validator: HdfsStoreReadSettings.validateDeleteFilesAfterCompletion
        }
    })
    public deleteFilesAfterCompletion?: boolean;
}
